import { rest } from "src/common/rest";
import { apiObjUrl } from "src/common/apiUrl";
import { restWithObjectVersion } from "src/common/restWithObjectVersion";
import { ZUid } from "src/types/zUid";
import { zStateReqAttributes } from "./RequiredAttributes.types";
import {
  ed2reqAttrs,
  EdReqAttributesDict,
  reqAttrs2ed,
} from "./EdRequiredAttributes";

export const loadObjReqAttributes = async (
  objectId: ZUid,
): Promise<EdReqAttributesDict> => {
  const resp = await restWithObjectVersion.get(
    apiObjUrl(`/objects/${objectId}/required-attributes`),
  );
  return reqAttrs2ed(zStateReqAttributes.array().parse(resp.data));
};

export const saveObjReqAttributes = async (
  objectId: ZUid,
  dict: EdReqAttributesDict,
) => {
  await rest.post(
    apiObjUrl(`/objects/${objectId}/required-attributes`),
    ed2reqAttrs(dict),
  );
};

export const checkEntitiesReqAttrs = async (
  entityIds: ZUid[],
): Promise<EdReqAttributesDict> => {
  const resp = await rest.post(
    apiObjUrl("/entities/required-attributes"),
    entityIds,
  );
  return reqAttrs2ed(zStateReqAttributes.array().parse(resp.data));
};
